import React from "react";
import { useNavigate } from "react-router-dom";
import "./10k.css";
import basicDiagram from "./images/basicdiagram.webp";
import { Helmet } from 'react-helmet';

const Kup9 = () => {
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>TKD Study - 10th Kup</title>
      </Helmet>
      <div className="belt-page">
        <div className="belt-content">
          <button className="back-button" onClick={() => navigate(-1)}>
            ← Back
          </button>
          <h2 className="belt-name">10th Kup – White Belt</h2>
          <div className="belt-description">
            White signifies innocence as that of a beginning student who has no
            previous knowledge of Taekwondo.
          </div>
          {/* Pattern 1: Saju Jirugi */}
          <div className="pattern-name">
            <b>
              <big>Pattern 1: Saju Jirugi</big>
            </b>
            <br />
            <b>Meaning:</b> Four Directional Punch
            <br />
            <b>Movements:</b> 14
          </div>
          <div
            className="video-link"
            dangerouslySetInnerHTML={{
              __html:
                '<b>Watch Here:</b> <a href="https://youtu.be/-jU-6897y9U" target="_blank">Youtube</a>',
            }}
          />
          <div className="video-diagram-row">
            <img
              src={basicDiagram}
              alt="Saju Jirugi Diagram"
              className="diagram-image"
            />
            <div className="moves-list">
              <b>
                <big>Moves:</big>
              </b>
              <br />
              <b>0:</b> <span style={{ color: "#0000AA" }}><b>Parallel Ready Stance</b></span> facing D<br />
              <b>1:</b> Right foot to D, right <b style={{ color: "#0000AA" }}>Walking Stance</b> to D, middle punch to D with right fist<br />
              <b>2:</b> Right foot to A, left <b style={{ color: "#0000AA" }}>Walking Stance</b> to B, low block to B with left forearm<br />
              <b>3:</b> Right foot to B, right <b style={{ color: "#0000AA" }}>Walking Stance</b> to B, middle punch to B with right fist<br />
              <b>4:</b> Right foot to D, left <b style={{ color: "#0000AA" }}>Walking Stance</b> to C, low block to C with left forearm<br />
              <b>5:</b> Right foot to C, right <b style={{ color: "#0000AA" }}>Walking Stance</b> to C, middle punch to C with right fist<br />
              <b>6:</b> Right foot to B, left <b style={{ color: "#0000AA" }}>Walking Stance</b> to A, low block to A with left forearm<br />
              <b>7:</b> Right foot to A, right <b style={{ color: "#0000AA" }}>Walking Stance</b> to A, middle punch to A with right fist<br />
              <b>END OF RIGHT SIDE</b> - Return to <b style={{ color: "#0000AA" }}>Ready Stance</b> facing D<br />
              <b>8:</b> Left foot to D, left <b style={{ color: "#0000AA" }}>Walking Stance</b> to D, middle punch to D with left fist<br />
              <b>9:</b> Left foot to B, right <b style={{ color: "#0000AA" }}>Walking Stance</b> to A, low block to A with right forearm<br />
              <b>10:</b> Left foot to A, left <b style={{ color: "#0000AA" }}>Walking Stance</b> to A, middle punch to A with left fist<br />
              <b>11:</b> Left foot to D, right <b style={{ color: "#0000AA" }}>Walking Stance</b> to C, low block to C with left forearm<br />
              <b>12:</b> Left foot to D, left <b style={{ color: "#0000AA" }}>Walking Stance</b> to D, middle punch to D with left fist<br />
              <b>13:</b> Left foot to A, right <b style={{ color: "#0000AA" }}>Walking Stance</b> to B, low block to B with right forearm<br />
              <b>14:</b> Left foot to B, left <b style={{ color: "#0000AA" }}>Walking Stance</b> to B, middle punch to B with left fist<br />
              <b>END</b> - Return to <b style={{ color: "#0000AA" }}>Ready Stance</b> facing D
            </div>
          </div>
          {/* Pattern 2: Saju Makgi */}
          <div className="pattern-name">
            <b>
              <big>Pattern 2: Saju Makgi</big>
            </b>
            <br />
            <b>Meaning:</b> Four Directional Block
            <br />
            <b>Movements:</b> 16
          </div>
          <div
            className="video-link"
            dangerouslySetInnerHTML={{
              __html:
                '<b>Watch Here:</b> <a href="https://youtu.be/nO9EmLaxbAA" target="_blank">Youtube</a>',
            }}
          />
          <div className="video-diagram-row">
            <img
              src={basicDiagram}
              alt="Saju Makgi Diagram"
              className="diagram-image"
            />
            <div className="moves-list">
              <b>
                <big>Moves:</big>
              </b>
              <br />
              <b>0:</b> <span style={{ color: "#0000AA" }}><b>Parallel Ready Stance</b></span> facing D<br />
              <b>1:</b> Right foot to C, left <b style={{ color: "#0000AA" }}>Walking Stance</b> to D, low block to D with left knife-hand<br />
              <b>2:</b> Right foot to D, right <b style={{ color: "#0000AA" }}>Walking Stance</b> to D, middle side block to D with right inner forearm<br />
              <b>3:</b> Right foot to A, left <b style={{ color: "#0000AA" }}>Walking Stance</b> to B, low block to B with left knife-hand<br />
              <b>4:</b> Right foot to B, right <b style={{ color: "#0000AA" }}>Walking Stance</b> to B, middle side block to B with right inner forearm<br />
              <b>5:</b> Right foot to D, left <b style={{ color: "#0000AA" }}>Walking Stance</b> to C, low block to C with left knife-hand<br />
              <b>6:</b> Right foot to C, right <b style={{ color: "#0000AA" }}>Walking Stance</b> to C, middle side block to C with right inner forearm<br />
              <b>7:</b> Right foot to B, left <b style={{ color: "#0000AA" }}>Walking Stance</b> to A, low block to A with left knife-hand<br />
              <b>8:</b> Right foot to A, right <b style={{ color: "#0000AA" }}>Walking Stance</b> to A, middle side block to A with right inner forearm<br />
              <b>END OF RIGHT SIDE</b> - Return to <b style={{ color: "#0000AA" }}>Ready Stance</b> facing D<br />
              <b>9:</b> Left foot to C, right <b style={{ color: "#0000AA" }}>Walking Stance</b> to D, low block to D with right knife-hand<br />
              <b>10:</b> Left foot to D, left <b style={{ color: "#0000AA" }}>Walking Stance</b> to D, middle side block to D with left inner forearm<br />
              <b>11:</b> Left foot to A, right <b style={{ color: "#0000AA" }}>Walking Stance</b> to B, low block to B with right knife-hand<br />
              <b>12:</b> Left foot to B, left <b style={{ color: "#0000AA" }}>Walking Stance</b> to B, middle side block to B with left inner forearm<br />
              <b>13:</b> Left foot to D, right <b style={{ color: "#0000AA" }}>Walking Stance</b> to C, low block to C with right knife-hand<br />
              <b>14:</b> Left foot to C, left <b style={{ color: "#0000AA" }}>Walking Stance</b> to C, middle side block to C with left inner forearm<br />
              <b>15:</b> Left foot to B, right <b style={{ color: "#0000AA" }}>Walking Stance</b> to A, low block to A with right knife-hand<br />
              <b>16:</b> Left foot to A, left <b style={{ color: "#0000AA" }}>Walking Stance</b> to A, middle side block to A with left inner forearm<br />
              <b>END</b> - Return to <b style={{ color: "#0000AA" }}>Ready Stance</b> facing D
            </div>
          </div>
          {/* Fundamental Moves Section */}
          <div className="fundamental-moves">
            <b><big>Fundamental Moves:</big></b><br />
            1) <span style={{ color: '#00AA00' }}><b>Bakat Palmok Najunde Makgi</b></span><br />
            Outer Forearm Low Block<br /><br />
            2) <span style={{ color: '#00AA00' }}><b>Ap Joomuk Kaunde Ap Jirugi</b></span><br />
            Front Fist Front Punch<br /><br />
            3) <span style={{ color: '#00AA00' }}><b>Sonkal Najunde Makgi</b></span><br />
            Knifehand Low Block<br /><br />
            4) <span style={{ color: '#00AA00' }}><b>An Palmok Kaunde Makgi</b></span><br />
            Inner Forearm Middle Block<br /><br />
            5) <span style={{ color: '#00AA00' }}><b>Bakat Palmok Chookyo Makgi</b></span><br />
            Outer Forearm Rising Block<br /><br />
            6) <span style={{ color: '#00AA00' }}><b>Ap Cha Busigi</b></span><br />
            Front Snap Kick<br /><br />
            7) <span style={{ color: '#00AA00' }}><b>Ap Cha Olligi</b></span><br />
            Front Rising Kick
          </div>
        </div>
      </div>
    </>
  );
};

export default Kup9;
